import './_hero-banner.scss';
import { sceneLoader } from '@/ts/utils/webgl';
import { ParticlesScene } from '@/ts/utils/webgl/scenes/particles.scene';

//Init HeroBanner component and enable better accessibility features.

export default function HeroBanner() {
    const $heroBanners = document.querySelectorAll('.hero-banner');

    if ($heroBanners) {
        $heroBanners.forEach(($heroBanner: any, index: number) => {
            const isAnimated = $heroBanner.classList.contains('v2');
            const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

            if (isAnimated && mediaQuery && !mediaQuery.matches && window.innerWidth >= 992) {
                const $backgroundImage = $heroBanner.querySelector('.background-image.desktop') as HTMLDivElement;
                if($backgroundImage){
                    $backgroundImage.classList.add('no-image');
                    sceneLoader.load(`hero-${index.toString()}`, new ParticlesScene($backgroundImage));
                    sceneLoader.render();
                }
            }
        });
    }
}
